<template>
    <div class="form-input-container">
        <div style="display: flex; align-items: center;">
            <v-select label="name" inputId="id" :clearable="false" :options="list" v-model="localValue"></v-select>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'stats-card',
        props: {
            value: {}, label: {}, list: {},
            required: {
                type: Boolean,
                default: true
            },
            type: {
                type: String,
                default: "text"
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                localValue: null
            }
        },
        created() {
            this.setFieldValue();
        },
        methods: {
            setFieldValue() {
                for(let i =0; i < this.list.length; i++) {
                if(this.list[i].id == this.value) {
                    this.localValue = this.list[i];
                }
            }
            },
        },
        watch: {
            localValue(val) {
                this.$emit('input', val.id)
            },
            value(val) {
                this.setFieldValue();
            },
            list(val) {

            }
        },
        computed: {
            model: {
                get() {
                    return this.localValue
                },
                set(value) {
                    if (value.constructor.name.toLowerCase() !== 'inputevent') {
                        this.$nextTick(() => {
                            this.localValue = value
                        })
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .form-input-container {
    }

    .v-select {
        width: 100%;
        border: 0px !important;
        border-radius: 6px;
        height: 38px;
    }

    .v-select:focus {
        border: 2px solid #353690;
    }
</style>


// WEBPACK FOOTER //
// src/components/Form/SelectTable.vue